import React, { forwardRef, useCallback, useMemo, useRef } from 'react';

// DEPENDENCIES
import { isFunction } from 'lodash';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions.js';

// LOCAL COMPONENTS
import Addon from '../../../parts/Addon';

// VARIABLES
const PREPENDS = {
}
const APPENDS = {
  password: {
    use: 'password'
  }
}

// MAIN COMPONENT
export const inputGroupAddons = Component => forwardRef(({
  prepend,
  append,
  ...props
}, ref) => {

  // PROPS
  const {
    type,
    schema,
    size,
    plaintext
  } = props;

  // REFS
  const internalRef = useRef();
  const input = ref || internalRef;

  // MEMOS
  prepend = useMemo(
    () => prepend || PREPENDS[type] || PREPENDS[schema] || {},
    [prepend, type, schema]
  )
  append = useMemo(
    () => append || APPENDS[type] || APPENDS[schema] || {},
    [append, type, schema]
  )

  // CLICK HANDLER
  const handleClick = useCallback(
    e => {
      doCallback(props.onClick, e);
      if (input.current && isFunction(input.current.focus)) input.current.focus();
    },
    [props.onClick, input]
  )
  // RENDER
  return (<>
    <Addon
      size={size}
      plaintext={plaintext}
      {...prepend}
      onClick={prepend.onClick || handleClick}
      prepend
    />
    <Component
      {...props}
      ref={ref}
    />
    <Addon
      size={size}
      plaintext={plaintext}
      {...append}
      onClick={append.onClick || handleClick}
      append
    />
  </>)
})
